"use client";
import React, { useState } from "react";
import CairaEventForm from "@/components/forms/CairaEventForm";
import { EventName, EventTypeEnum, FormHeading } from "@/interface/types";

interface CairaEventBannerProps {
  data: {
    bannerTitle: string;
    bannerData: {
      bannerAlt: string;
      bannerUrl: string;
    };
    eventDateAndTime: {
      date: string;
      time: string;
    };
    formLink: string | null;
    statisticsStrip: {
      duration: string;
      found_it_useful: string;
      learners: string;
    };
  };
  eventMetaData: {
    city: string;
    city_id: number;
    courseId: number;
    courseName: string;
    eventId: string;
    eventName: string;
    eventType: string;
    orientation_id: number;
    zoomWebinarId: string;
  };
}

const FixedRegisterButton: React.FC<CairaEventBannerProps> = ({
  data,
  eventMetaData,
}) => {
  let {
    courseId,
    eventId,
    eventName,
    eventType,
    city_id,
    city,
    courseName,
    orientation_id,
  } = eventMetaData;
  let { date, time } = data.eventDateAndTime;

  const isOffline = eventType === EventTypeEnum.OFFLINE;

  const [isformPopupOpen, setformPopupOpen] = useState(false);
  const openformPopup = () => {
    setformPopupOpen(true);
  };

  const closeformPopup = () => {
    setformPopupOpen(false);
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          bottom: "0px",
          width: "100%",
          height: "12%",
          background: "rgba(6, 26, 47, 0.30)",
          backdropFilter: "blur(4px)",
          display: "flex",
          justifyContent: "center",
          zIndex: 99,
        }}
      >
        <button className="float_btn" onClick={openformPopup}>
          Register
        </button>
      </div>
      {isformPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999] lg:p-10 p-1">
          <div
            className="p-6 w-full md:w-[400px] rounded-2xl border"
            style={{
              background: "rgba(6, 26, 47, 0.85)",
              boxShadow: "0 0 54.9px 0 rgba(166, 137, 255, 0.40) inset",
              borderColor: "rgba(255, 255, 255, 0.15)",
              backdropFilter: "blur(12px)",
            }}
          >
            <button
              onClick={closeformPopup}
              className="mt-6 text-[#878787] px-3 text-lg py-1 rounded absolute md:right-[10px] right-[5px] md:top-0 top-[-19px] z-[9999]"
            >
              ✕
            </button>
            <CairaEventForm
              isOfflineFrom={isOffline}
              cityId={city_id}
              courseId={courseId}
              courseName={courseName}
              eventId={eventId}
              cityName={city}
              eventType={EventName.CAIRA}
              eventName={eventName}
              formHeading={FormHeading.JOIN_US_LIVE_WITH_VARUN_JAIN}
              eventDate={date}
              eventTime={time}
              submitButtonName="Apply Now"
              orientationId={orientation_id}
              isDarkBackground
            />
          </div>
        </div>
      )}
    </>
  );
};

export default FixedRegisterButton;
